/**
 * Gets the current system time in seconds
 * This was initially extracted to allow us to stub the time when testing things that depend on it
 * @returns the current system time in seconds
 */
export function epoch() {
  return Math.floor(Date.now() / 1000);
}
